import { render, staticRenderFns } from "./nominalSetting.vue?vue&type=template&id=170f7295&scoped=true&"
import script from "./nominalSetting.vue?vue&type=script&lang=js&"
export * from "./nominalSetting.vue?vue&type=script&lang=js&"
import style0 from "./nominalSetting.vue?vue&type=style&index=0&id=170f7295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f7295",
  null
  
)

export default component.exports